import IMAGES from "@/public/assets/img";

const FreightLoanData = {
  seoData: {
    title:
      "Freight Invoice Discounting: Boost Logistics Cash Flow with Credlix",
    description:
      "Convert outstanding freight bills into immediate working capital with freight invoice discounting. Get faster payments, improve cash flow, and grow your logistics or transport business.!",
    keywords:
      "freight invoice discounting, export finance, working capital, Indian exporters, collateral-free loans, quick disbursal, cash flow, MSME finance, trade finance, export logistics, instant cash flow, Credlix.",
  },

  bannerHeading: "Don't Let Freight Bills​",
  subheading: "Hold You Back",
  btntext: "Propel You ​Exports Forward​",
  paraLoan: '<span class="text-heading1 sm:text-3xl md:text-3xl">Unlock Growth with</span> <br /> <span class="font-semibold text-3xl sm:text-xl"> Freight Invoice Discounting </span>',

  loanInfo: [
    {
      icon: IMAGES.FreightLoan.instant,
      description: "Instant Capital from Freight bills",
    },
    {
      icon: IMAGES.FreightLoan.saveMore,
      description: "Pay promptly Save More",
    },
    {
      icon: IMAGES?.FreightLoan.cash,
      description: "Bridge Cash Flow Gap",
    },
  ],

  Challenge: {
    sectionTitle: "The Exporter’s Challenge",
    mainHeading: "Navigating the Freight Maze",
    description:
      "Indian exporters face escalating freight costs—global container rates have quadrupled—squeezing margins and tying up working capital.<br/> Hidden fees (dimensional weight, fuel surcharges, duplicate billing) further erode profitability and strain logistics partnerships, risking missed carrier discounts and delayed shipments.",
    subSectionTitle: "Your Smooth-Sailing Partner",
    subSectionDescription:
      "Credlix converts ocean and inland freight bills into instant working capital—up to 90% disbursed within 48 hours—unlocking funds tied in receivables. Seamless liquidity lets you:",
    benefits: [
      {
        icon: IMAGES?.FreightLoan.pay,
        text: "Pay carriers promptly to secure better rates and strengthen relationships",
      },
      {
        icon: IMAGES?.FreightLoan.reallocate,
        text: "Reallocate capital toward production, marketing, or new orders",
      },
      {
        icon: IMAGES?.FreightLoan.building,
        text: "Transform freight from cost center to competitive advantage",
      },
    ],
  },

  HowItWorks: {
    heading: "How It Works",
    subHeading: "Simple Steps to Swift Funds​",
    steps: [
      {
        id: "1",
        para: "Submit Freight Bills",
        title: "Upload Ocean and Inland invoices.​",
      },
      {
        id: "2",
        para: "Get Funds in 48 Hours",
        title: "Instant Credit to your account.",
      },
      {
        id: "3",
        para: "Focus on Growth",
        title: "Use freed-up Capital to drive orders and scale.​",
      },
    ],
  },

  buyerCredit: {
    sectionTitle: "Know Before you Trade",
    mainHeading: "Credlix offers real-time, detailed, and in-depth",
    mainSubHeading: "analysis of your buyers",
    benefits: [
      {
        icon: IMAGES?.MachineryLoan.creditcheck,
        text: "Real Time Credit Check",
      },
      {
        icon: IMAGES?.MachineryLoan.reports,
        text: "Detailed Reports",
      },
      {
        icon: IMAGES?.MachineryLoan.analysis,
        text: "In-Depth Analysis​",
      },
    ],
  },

  bannerCTA: {
    title: "Ready to Accelerate? Your Journey Starts Here! ",
    description:
      "Gain the speed, flexibility, and financial freedom to propel your exports globally. ",
    button: {
      label: "Get Freight Invoice Discounting Now",
      link: "/apply-machinery-loan",
    },
  },

  FaqHead: "Frequently Asked Questions (FAQs)",
  Faq: [
    {
      id: 0,
      question: "What is Freight Invoice Discounting?",
      answers:
        "A solution converting outstanding freight bills into immediate working capital.",
    },
    {
      id: 1,
      question: "How quickly can I get funds?",
      answers: "Typically within 48 hours of approval.",
    },
    {
      id: 2,
      question: "Is collateral required?",
      answers: "No—freight invoices serve as security.",
    },
    {
      id: 3,
      question: "How does Credlix mitigate hidden costs?",
      answers:
        "Prompt payments often secure better carrier terms, reducing surprise fees.",
    },
    {
      id: 4,
      question: "What fees apply?",
      answers:
        "Competitive, transparent discount rates disclosed upfront during application.",
    },
    {
      id: 5,
      question: "What documents are needed?",
      answers:
        "Minimal documentation—business and financial proofs—detailed online.",
    },
    {
      id: 6,
      question: "How is this different from bank loans?",
      answers:
        "Faster approvals, paperless process, and collateral-free terms address common bank loan pain points.",
    },
    {
      id: 7,
      question: "Can I finance both ocean and inland freight?",
      answers: "Yes, for all export logistics invoices.",
    },
    {
      id: 8,
      question: "Will buyers know I’m using Credlix?",
      answers: "No—our process is confidential and discreet.",
    },
  ],
};
export default FreightLoanData;
